import React from 'react';

import { withDocumentTitle } from '../../generic/DocumentTitle';
import add from '../../REST/add';
import api from '../../REST/api';
import { tapFlashSuccess } from '../../utils/flash';
import UserForm from '../UserForm';

const AddUserForm = add({
  update: (props, model) =>
    api
      .addUser({
        data: model,
      })
      .then(tapFlashSuccess('User has been created')),
  form: props => <UserForm newModel {...props} />,
  redirectTo: '/users/:id/show',
});

const AddUser = props => {
  const userDefaults = { number: '', roles: [] };

  return <AddUserForm {...props} default={userDefaults} />;
};

export default withDocumentTitle('Create User')(AddUser);
